import React from 'react';
import { Text, Title, Button } from '@soluto-design/react';
import { LinkProps } from '@soluto-design/link';
import CardBase from '../CardBase';
import cls from '@soluto-design/styles/cls';

export interface CardPricingProps {
    title: string;
    description?: string;
    features?: string;
    value?: string;
    theme?: 'Primary' | 'Secondary' | 'Tertiary' | 'Quaternary';
    cta?: LinkProps;
    variant?: 'large' | 'small';
}

export default function CardPricing({
    title,
    description,
    value,
    features,
    theme = 'Secondary',
    cta,
    variant = 'small',
}: CardPricingProps) {
    return (
        <CardBase
            dataTheme={theme}
            className={cls(
                "relative overflow-hidden rounded-large bg-background-secondary px-lg pb-lg pt-[calc(var(--soluto-spacing-lg)+16px)] flex flex-col before:content-[''] before:absolute before:top-0 before:left-0 before:h-16 before:w-full before:bg-background-brand-primary",
            )}>
            {!!title && (
                <Title
                    component="h4"
                    className={cls(
                        'text-text-brand-1',
                        {
                            'text-h300': variant === 'large',
                            'text-h400 ': variant === 'small',
                        },
                        !value && !description && !!features
                            ? 'pb-lg'
                            : 'pb-16',
                    )}>
                    {title}
                </Title>
            )}
            {!!value && (
                <Text
                    isHtml
                    component="div"
                    className={cls(
                        'pb-16 text-b400 text-text-secondary [&_strong]:text-b100 [&_strong]:!font-regular [&_b]:text-b100 [&_b]:!font-regular',
                    )}>
                    {value}
                </Text>
            )}
            {!!description && (
                <Text
                    isHtml
                    component="div"
                    className={cls(
                        'text-b300 !text-spacers text-text-secondary',
                        {
                            'lg:min-h-[144px] hd:min-h-[120px] lg:[&_p+p]:mt-0 lg:flex lg:flex-col lg:justify-between':
                                !!features,
                            'mb-xl': !!features && variant === 'large',
                            'mb-lg': !!features && variant === 'small',
                        },
                    )}>
                    {description}
                </Text>
            )}
            {!!features && (
                <Text
                    isHtml
                    component="div"
                    className={cls(
                        'text-b400 text-text-primary themed-icon-list',
                        {
                            'pb-xl': !!cta,
                        },
                    )}>
                    {features}
                </Text>
            )}
            {cta && (
                <Button
                    variant="primary"
                    className="mt-auto xl:w-auto"
                    size="large"
                    {...cta}
                />
            )}
        </CardBase>
    );
}
